// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  RichTextField,
  SimpleList,
} from "react-admin";
import useWindowWidthBreakpoints from "use-window-width-breakpoints";
import RichTextInput from "ra-input-rich-text";

const FaqFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="question" alwaysOn />
  </Filter>
);

export const FaqList = (props) => {
  const breakpoint = useWindowWidthBreakpoints({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  });
  return (
    <List {...props} filters={<FaqFilter />}>
      {breakpoint.down.sm ? (
        <SimpleList
          primaryText={(record) => record.title}
          tertiaryText={(record) =>
            new Date(record.createdate).toLocaleDateString()
          }
          linkType={(record) => (record.canEdit ? "edit" : "show")}
        />
      ) : (
        <Datagrid>
          <TextField source="question" />
          <TextField source="createdate" />
          <TextField source="lastupdate" />
          <ShowButton label="" />
          <EditButton label="" />
          <DeleteButton label="" redirect={false} />
        </Datagrid>
      )}
    </List>
  );
};

export const FaqShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="question" />
      <RichTextField source="answer" />
      <TextField source="createdate" />
      <TextField source="lastupdate" />
    </SimpleShowLayout>
  </Show>
);

export const FaqCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="question" validation={{ required: true }} />
      <RichTextInput
        toolbar={[
          ["bold", "italic", "underline", "strike"],
          ["blockquote"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["clean"],
        ]}
        source="answer"
        validation={{ required: true }}
      />
    </SimpleForm>
  </Create>
);

export const FaqEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="question" validation={{ required: true }} />
      <RichTextInput
        toolbar={[
          ["bold", "italic", "underline", "strike"],
          ["blockquote"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["clean"],
        ]}
        source="answer"
        validation={{ required: true }}
      />
    </SimpleForm>
  </Edit>
);
